import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import './Testimonials.css';

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const testimonials = [
  {
    name: 'Naresh C',
    description: 'Excellent doctor, treatment is very good.',
    image: 'https://i.ibb.co/SX5H4RRC/Image-Placeholder-1.png',
  },
  {
    name: 'Shiva Karunakar',
    description: 'Good Doctor, Dr. Shruti Sagar Garu, Excellent Treatment. He is equal to God for liver patients.',
    image: 'https://i.ibb.co/QvwNJZRR/Image-Placeholder-6.png',
  },
  {
    name: 'Jaharabe Shaik',
    description: 'Shiva sir took care of us in the hospital. He is very friendly, communicates well, and guided us throughout the day. Excellent service!',
    image: 'https://i.ibb.co/Kj4yN8zZ/Image-Placeholder-5.png',
  },
];
const Testimonials = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  // Scroll fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Krisara Gastro and Liver Clinic",
    "image": "https://i.ibb.co/VYmQ8jXQ/Save-Clip-App-469483120-17864062791277450-3833299510464549824-n-1.png",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": testimonials.length.toString()
    },
    "review": testimonials.map((t) => ({
      "@type": "Review",
      "author": { "@type": "Person", "name": t.name },
      "reviewBody": t.description,
      "reviewRating": { "@type": "Rating", "ratingValue": "5" }
    }))
  };
  return (
    <section
      ref={sectionRef}
      className={`testimonials-section ${isVisible ? 'animate' : ''}`}
    >
      {/* SEO Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(reviewSchema)}
        </script>
      </Helmet>
      <div className="container">
        <h2
          className="testimonials-title fade-up"
          style={{ transitionDelay: '0.2s' }}
        >
          Real People. Real Transformations.
        </h2>
        <p
          className="testimonials-subtitle fade-up"
          style={{ transitionDelay: '0.4s' }}
        >
          Hear what our happy clients have to say about their health journeys.
        </p>
        <div className="testimonials-grid">
          {testimonials.map((t, index) => (
            <div
              className="testimonial-card fade-up"
              key={index}
              style={{ transitionDelay: `${0.6 + index * 0.2}s` }}
            >
              <img src={t.image} alt={t.name} className="testimonial-img" />
              <p className="testimonial-description">{t.description}</p>
              <p className="testimonial-name">{t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Testimonials;